<i class="fas fa-arrow-left" data-fa-symbol="left"></i>
<i class="fas fa-arrow-right" data-fa-symbol="right"></i>

<div class="wrapper">
  <div class="d-flex flex-column lista" *ngIf="selected">
    <div class="align-content-start" style="margin-bottom: 0.4em;">
      <button class="btn btn-outline-success" *ngIf="selected" (click)="selected = false">
        {{'Return' | translate}}
      </button>
    </div>
    <ng-container *ngFor="let single of list; let i = index">
      <div class="d-flex align-items-center flex-column" (click)="setActive(single.name)" *ngIf="i<=10 || show" style="cursor: pointer">
        <div class="d-flex align-items-center flex-row list-block">
          <div class="text">
            {{single.name}}
          </div>
          <div class="text">
            {{single.amount}}
          </div>
        </div>
        <div class="d-flex flex-column details-block" *ngIf="isActive(single.name)" style="width: 100%;">
          <div class="d-flex flex-column" *ngFor="let s of alarmDetails">
            <div class="d-flex flex-row target-list">
              <div>
                {{s.name}}
              </div>
              <div>
                {{s.amount}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="show" *ngIf="list.length > 10">
      <a class="linkki" (click)="show  = !show">
        <span *ngIf="show">{{'Show less' | translate}}</span>
        <span *ngIf="!show">{{'Show more' | translate}}</span>
      </a>
    </div>
  </div>


  <div class="d-flex flex-column align-content-around align-items-center data-row" style="width: 100%;"  *ngIf="alarms.length >= 14 && !selected">
    <div class="arrow-buttons">
      <div class="arrow">
        <a class="link" (click)="loadMore('previous')">
          <svg class="svg-inline--fa fa-w-20">
            <use xlink:href="#left"></use>
          </svg>
        </a>
      </div>
      <div class="header">
        <span>{{dateArr[0] | qmDateFormat: 'dd.MM.yyyy'}} – {{dateArr[13] | qmDateFormat: 'dd.MM.yyyy'}}</span>
      </div>
      <div class="arrow">
        <a class="link" (click)="loadMore('next')">
          <svg class="svg-inline--fa fa-w-20">
            <use xlink:href="#right"></use>
          </svg>
        </a>
      </div>
    </div>
    <div class="diagram-container" *qmLoading="loading">
      <ngx-charts-bar-vertical
        (select)="selectBar($event)"
        [results]="alarms"
        [legend]="false"
        [showYAxisLabel]="true"
        [showDataLabel]="true"
        [animations]="false"
        [tooltipDisabled]="false">
      </ngx-charts-bar-vertical>
    </div>
  </div>
</div>

